module.exports = __webpack_public_path__ + "img/43.1.9e20b226.jpg";